// extracted by mini-css-extract-plugin
export default {"ProducCategoryText":"ProductCategoryText_ProducCategoryText__i1vpi"};